import styled from 'styled-components'

const SimpleSwitchContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: nowrap;
  width: 128px;
  max-width: 128px;
  padding: 13px 8px;
`

export default SimpleSwitchContainer
